/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPipelineAlt = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M22 8V2h-6v2h-5v7H8V9H2v6h6v-2h3v7h5v2h6v-6h-6v2h-3v-5h3v2h6V9h-6v2h-3V6h3v2h6zm-4-4h2v2h-2V4zM6 13H4v-2h2v2zm12 5h2v2h-2v-2zm0-7h2v2h-2v-2z"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgPipelineAlt as PipelineAlt };
